<script>
	let OpenFilter = false;
	let OpenSort = false;
	import { fade, fly } from 'svelte/transition';
  
  
  import Loader from '$lib/components/Loader.svelte';
	export let colors = [];
	export let sizes = [];
	export let brands = [];

	export let colors__id = '';
  export let count
	export let sizes__id = '';
	export let brands__id = '';

	export let OnFilterSort;
	export let OnFilterSend;
  export let load
 
	// Функция обновления ID и вызова OnFilterSend
	function updateFilter(selectedId, idList, setIdList) {
		const ids = idList.split(',').filter(Boolean); // Разбиваем строку в массив

		if (ids.includes(selectedId)) {
			// Удаляем ID, если он уже выбран
			setIdList(ids.filter((id) => id !== selectedId).join(','));
		} else {
			// Добавляем новый ID
			setIdList([...ids, selectedId].join(','));
		}
  
		OnFilterSend();
  
	}

	// Функция для подсчета выбранных фильтров
	function getSelectedFilterCount() {
		return [colors__id, sizes__id, brands__id].filter((id) => id && id !== '').length;
	}
</script>

<section
	aria-labelledby="filter-heading"
	class="grid items-center border-b border-t border-gray-200"
>
	<h2 id="filter-heading" class="sr-only">Filters</h2>

	<div class="relative col-start-1 row-start-1 py-4">
		<div class="mx-auto flex space-x-6 divide-x divide-gray-200 px-4 text-sm sm:px-6 lg:px-8">
			<div>
				<button
					on:click={() => (OpenFilter = !OpenFilter)}
					type="button"
					class="group flex items-center font-medium text-gray-700"
				>
					<svg
						class="mr-2 size-5 flex-none text-gray-400 group-hover:text-gray-500"
						aria-hidden="true"
						viewBox="0 0 20 20"
						fill="currentColor"
					>
						<path
							fill-rule="evenodd"
							d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 0 1 8 18.25v-5.757a2.25 2.25 0 0 0-.659-1.591L2.659 6.22A2.25 2.25 0 0 1 2 4.629V2.34a.75.75 0 0 1 .628-.74Z"
							clip-rule="evenodd"
						/>
					</svg>
					Фильтры ({[colors__id, sizes__id, brands__id].filter((id) => id && id !== '').length})
				</button>
			</div>
			<div class="pl-6">
				{#if [colors__id, sizes__id, brands__id].filter((id) => id && id !== '').length > 0}
					<button
						on:click={() => {
							colors__id = '';
							sizes__id = '';
							brands__id = '';
							OnFilterSend();
						}}
						type="button"
						class="text-gray-500">Сбросить</button
					>
				{/if}
			</div>
		</div>
	</div>
	<div class="md:block hidden">
		{#if OpenFilter}
			<div class="border-t border-gray-200 py-10">
				<div class="mx-auto grid grid-cols-2 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
					{#if colors.length > 1}
						<div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-2 md:gap-x-6">
							<fieldset>
								<legend class="block font-medium">Цвет</legend>
								<div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4 h-[50vh] overflow-auto">
									{#each colors as color}
										<div class="flex gap-3">
											<input
												type="checkbox"
												id={`color-${color.id}`}
												class="rounded border-gray-300"
												checked={colors__id.split(',').includes(color.id.toString())}
												on:change={() =>
													updateFilter(
														color.id.toString(),
														colors__id,
														(newId) => (colors__id = newId)
													)}
											/>
											<label for={`color-${color.id}`} class="text-base text-gray-600"
												>{color.name}</label
											>
										</div>
									{/each}
								</div>
							</fieldset>
						</div>
					{/if}

					<div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-2 md:gap-x-6">
						{#if sizes.length > 1}
							<fieldset>
								<legend class="block font-medium">Размер</legend>
								<div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4 h-[50vh] overflow-auto">
									{#each sizes as size}
										<div class="flex gap-3">
											<input
												type="checkbox"
												id={`size-${size.id}`}
												class="rounded border-gray-300"
												checked={sizes__id.split(',').includes(size.id.toString())}
												on:change={() =>
													updateFilter(
														size.id.toString(),
														sizes__id,
														(newId) => (sizes__id = newId)
													)}
											/>
											<label for={`size-${size.id}`} class="text-base text-gray-600"
												>{size.international}</label
											>
										</div>
									{/each}
								</div>
							</fieldset>
						{/if}
						{#if brands.length > 1}
							<fieldset>
								<legend class="block font-medium">Бренд</legend>
								<div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
									{#each brands as brand}
										<div class="flex gap-3">
											<input
												type="checkbox"
												id={`brand-${brand.id}`}
												class="rounded border-gray-300"
												checked={brands__id.split(',').includes(brand.id.toString())}
												on:change={() =>
													updateFilter(
														brand.id.toString(),
														brands__id,
														(newId) => (brands__id = newId)
													)}
											/>
											<label for={`brand-${brand.id}`} class="text-base text-gray-600"
												>{brand.name}</label
											>
										</div>
									{/each}
								</div>
							</fieldset>
						{/if}
					</div>
				</div>
			</div>
		{/if}
	</div>
	<!-- mobile -->
	<div class="md:hidden block">
		{#if OpenFilter}
			<div
				style="z-index: 1000"
				class="relative"
				aria-labelledby="slide-over-title"
				role="dialog"
				aria-modal="true"
			>
				<!-- Background backdrop, show/hide based on slide-over state. -->
				<div class="fixed bg-custom-black opacity-70 inset-0" />

				<div
					transition:fly={{
						x: 200,
						duration: 500
					}}
					class="fixed inset-0"
				>
					<div class="absolute inset-0 overflow-hidden">
						<div
							class="pointer-events-none fixed inset-y-0 right-0 flex items-end max-w-full md:pl-10 sm:pl-16"
						>
							<div
								class="pointer-events-auto w-screen h-[100vh] md:h-screen md:w-screen md:max-w-2xl"
							>
								<div class="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
									<div class="px-4 sm:px-6">
										<div class="flex items-start justify-between">
											<h2
												class="text-base font-semibold leading-6 text-gray-900"
												id="slide-over-title"
											/>
											<div class="ml-3 md:flex items-center">
												<button
                        on:click={() => (OpenFilter = !OpenFilter)}
													type="button"
													class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
												>
													<span class="sr-only">Close panel</span>
													<svg
														class="h-6 w-6"
														fill="none"
														viewBox="0 0 24 24"
														stroke-width="1.5"
														stroke="currentColor"
														aria-hidden="true"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															d="M6 18L18 6M6 6l12 12"
														/>
													</svg>
												</button>
											</div>
										</div>
									</div>
									<div class="relative mt-6 flex-1 px-4 pt-0 md:pt-[19px] sm:px-6">
										<div class="w-full">
											<h2 class="text-2xl hidden md:block text-custom-gray text-left" />
                      {#if load}
						            <Loader/>
                      {/if}
                      <div class="border-t border-gray-200 py-10">
                        <div class="mx-auto grid grid-cols-1 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
                          {#if colors.length > 1}
                            <div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-2 md:gap-x-6">
                              <fieldset >
                                <legend class="block font-bold text-lg">Цвет</legend>
                                <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4 h-[50vh] overflow-auto">
                                  {#each colors as color}
                                    <div class="flex gap-3">
                                      <input
                                        type="checkbox"
                                        id={`color-${color.id}`}
                                        class="rounded border-gray-300"
                                        checked={colors__id.split(',').includes(color.id.toString())}
                                        on:change={() =>
                                          updateFilter(
                                            color.id.toString(),
                                            colors__id,
                                            (newId) => (colors__id = newId)
                                          )}
                                      />
                                      <label for={`color-${color.id}`} class="text-base text-gray-600"
                                        >{color.name}</label
                                      >
                                    </div>
                                  {/each}
                                </div>
                              </fieldset>
                            </div>
                          {/if}
                
                          <div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-2 md:gap-x-6">
                            {#if sizes.length > 1}
                            <div class="relative">
                              <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                <div class="w-full border-t border-gray-300"></div>
                              </div>
                              <div class="relative flex justify-center">
                                <span class="bg-white px-2 text-sm text-gray-500"></span>
                              </div>
                            </div>
                            
                              <fieldset class="mt-4">
                                <legend class="block font-bold text-lg">Размер</legend>
                                <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4 h-[50vh] overflow-auto">
                                  {#each sizes as size}
                                    <div class="flex gap-3">
                                      <input
                                        type="checkbox"
                                        id={`size-${size.id}`}
                                        class="rounded border-gray-300"
                                        checked={sizes__id.split(',').includes(size.id.toString())}
                                        on:change={() =>
                                          updateFilter(
                                            size.id.toString(),
                                            sizes__id,
                                            (newId) => (sizes__id = newId)
                                          )}
                                      />
                                      <label for={`size-${size.id}`} class="text-base text-gray-600"
                                        >{size.international}</label
                                      >
                                    </div>
                                  {/each}
                                </div>
                              </fieldset>
                            {/if}
                            {#if brands.length > 1}
                              <fieldset class="mt-4">
                                <div class="relative">
                                  <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                    <div class="w-full border-t border-gray-300"></div>
                                  </div>
                                  <div class="relative flex justify-center">
                                    <span class="bg-white px-2 text-sm text-gray-500"></span>
                                  </div>
                                </div>
                                
                                <legend class="block font-bold text-lg">Бренд</legend>
                                <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
                                  {#each brands as brand}
                                    <div class="flex gap-3">
                                      <input
                                        type="checkbox"
                                        id={`brand-${brand.id}`}
                                        class="rounded border-gray-300"
                                        checked={brands__id.split(',').includes(brand.id.toString())}
                                        on:change={() =>
                                          updateFilter(
                                            brand.id.toString(),
                                            brands__id,
                                            (newId) => (brands__id = newId)
                                          )}
                                      />
                                      <label for={`brand-${brand.id}`} class="text-base text-gray-600"
                                        >{brand.name}</label
                                      >
                                    </div>
                                  {/each}
                                </div>
                              </fieldset>
                            {/if}
                            <div class="fixed bottom-1 left-0 w-full flex justify-center px-4">
                              <button 
                              on:click={() => {
                                OpenFilter = false
                              }}
                        
                              class="bg-[#3D3D3D]  z-10 mt-3 w-full py-2 px-4 text-white"
                            >
                            Показать {count}
                            </button>
                            </div>
                 
                          </div>
                        </div>
                      </div>
								
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		{/if}
	</div>
	<div class="col-start-1 row-start-1 py-4">
		<div class="mx-auto flex justify-end px-4 sm:px-6 lg:px-8">
			<div class="relative inline-block">
				<div class="flex">
					<button
						on:click={() => {
							OpenSort = !OpenSort;
						}}
						type="button"
						class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
						id="menu-button"
						aria-expanded="false"
						aria-haspopup="true"
					>
						Сортировка
						<svg
							class="-mr-1 ml-1 size-5 shrink-0 text-gray-400 group-hover:text-gray-500"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
							data-slot="icon"
						>
							<path
								fill-rule="evenodd"
								d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
								clip-rule="evenodd"
							/>
						</svg>
					</button>
				</div>

				{#if OpenSort}
					<div
						class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black/5 focus:outline-none"
						role="menu"
						aria-orientation="vertical"
						aria-labelledby="menu-button"
						tabindex="-1"
					>
						<div class="py-1" role="none">
							<button
								on:click={() => {
									OnFilterSort('popular');
								}}
								class="block px-4 py-2 text-sm font-medium text-gray-900"
								role="menuitem"
								tabindex="-1"
								id="menu-item-0">Популярность</button
							>
							<button
								on:click={() => {
									OnFilterSort('-id');
								}}
								class="block px-4 py-2 text-sm text-gray-500"
								role="menuitem"
								tabindex="-1"
								id="menu-item-1">Новинки</button
							>
							<button
								on:click={() => {
									OnFilterSort('-price');
								}}
								class="block px-4 py-2 text-sm text-gray-500"
								role="menuitem"
								tabindex="-1"
								id="menu-item-2">Цена больше</button
							>
							<button
								on:click={() => {
									OnFilterSort('price');
								}}
								class="block px-4 py-2 text-sm text-gray-500"
								role="menuitem"
								tabindex="-1"
								id="menu-item-3">Цена меньше</button
							>
						</div>
					</div>
				{/if}
			</div>
		</div>
	</div>
</section>
